/** Contexto de saida que nao sabe nada — util em teste e no caminho canonico. */
export const CONTEXTO_SAIDA_VAZIO = {
    camposDoServidor: () => ({}),
    descricaoDaVerba: () => "",
};
//# sourceMappingURL=adaptador.js.map